import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: '首頁', path: '/' },
    { name: '套裝行程', path: '/packages' },
    { name: '最新消息', path: '/news' },
    { name: '聯絡我們', path: '/contact' },
  ];

  const bgColor = isHome 
    ? (isScrolled ? 'bg-white shadow-md text-slate-800' : 'bg-transparent text-white') 
    : 'bg-white shadow-md text-slate-800';

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${bgColor}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-2">
            <SafeIcon name="Navigation" className="text-3xl text-blue-500" />
            <span className="font-bold text-xl md:text-2xl tracking-wider">
              龜山島快樂遊
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8 items-center">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="hover:text-blue-500 font-medium transition-colors"
              >
                {link.name}
              </Link>
            ))}
            <a 
              href="tel:0910071850" 
              className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-full font-medium transition-colors shadow-lg"
            >
              立即預約
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="focus:outline-none"
            >
              <SafeIcon name={isMenuOpen ? "X" : "Menu"} className="text-3xl" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white text-slate-800 shadow-xl absolute w-full left-0">
          <div className="px-4 pt-2 pb-6 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className="block px-3 py-3 rounded-md text-base font-medium hover:bg-blue-50 hover:text-blue-600"
              >
                {link.name}
              </Link>
            ))}
            <a 
              href="tel:0910071850" 
              className="block w-full text-center mt-4 bg-orange-500 text-white px-6 py-3 rounded-md font-medium"
            >
              立即預約: 0910-071850
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;